/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    eventType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    severity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    read?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly objectType: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    message: string;
    /**
     * Whether this notification has been enhanced by AI
     * @type {boolean}
     * @memberof Notification
     */
    aiEnhanced?: boolean;
    /**
     * Whether this notification has been sent via email
     * @type {boolean}
     * @memberof Notification
     */
    emailAlerted?: boolean;
    /**
     * Whether this notification has been sent to Slack
     * @type {boolean}
     * @memberof Notification
     */
    slackAlerted?: boolean;
    /**
     * Whether this notification has been displayed on the dashboard
     * @type {boolean}
     * @memberof Notification
     */
    dashboardAlerted?: boolean;
}

/**
 * Check if a given object implements the Notification interface.
 */
export function instanceOfNotification(value: object): value is Notification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('objectType' in value) || value['objectType'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventType': json['event_type'] == null ? undefined : json['event_type'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'read': json['read'] == null ? undefined : json['read'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'objectType': json['object_type'],
        'title': json['title'] == null ? undefined : json['title'],
        'message': json['message'],
        'aiEnhanced': json['ai_enhanced'] == null ? undefined : json['ai_enhanced'],
        'emailAlerted': json['email_alerted'] == null ? undefined : json['email_alerted'],
        'slackAlerted': json['slack_alerted'] == null ? undefined : json['slack_alerted'],
        'dashboardAlerted': json['dashboard_alerted'] == null ? undefined : json['dashboard_alerted'],
    };
}

  export function NotificationToJSON(json: any): Notification {
      return NotificationToJSONTyped(json, false);
  }

  export function NotificationToJSONTyped(value?: Omit<Notification, 'id'|'object_type'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_type': value['eventType'],
        'severity': value['severity'],
        'read': value['read'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'title': value['title'],
        'message': value['message'],
        'ai_enhanced': value['aiEnhanced'],
        'email_alerted': value['emailAlerted'],
        'slack_alerted': value['slackAlerted'],
        'dashboard_alerted': value['dashboardAlerted'],
    };
}

